module.exports = __webpack_public_path__ + "static/media/check-tick.683da335.svg";